<template>
  <div>
    <el-tabs v-model="activeName" tab-position="left" class="XJTab">
      <el-tab-pane v-for="(item, index) in XJList" :key="index" :label="item.name" :name="item.name">
        <el-row>
          <div class="contentTitle"
               style="color: #ee7a18; font-size: 36px; padding: 20px 100px">
            {{that.$root.language == 1?item.textName:item.textName_en}}
          </div>
          <div class="content" style="padding: 20px 100px">
            <div class="top" style="padding-bottom: 20px; font-size: 24px">
              {{that.$root.language == 1?'1、产品概述':'1. GENERAL DESCRIPTION'}}
            </div>
            <div v-show="item.description1" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description1:item.description1_en}}
            </div>
            <div v-show="item.description2" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description2:item.description2_en}}
            </div>
            <div v-show="item.description3" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description3:item.description3_en}}
            </div>
            <div v-show="item.description4" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description4:item.description4_en}}
            </div>
            <div v-show="item.description5" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description5:item.description5_en}}
            </div>
            <div v-show="item.description6" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description6:item.description6_en}}
            </div>
            <img v-if="that.$root.language == 1" v-show="item.img1" :src="item.img3"
                 style="width: 100%" />
            <img v-if="that.$root.language != 1" v-show="item.img1" :src="item.img3_en"
                 style="width: 100%" />
            <div v-show="item.description7" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description7:item.description7_en}}
            </div>
            <div class="center" style="padding: 20px 0; font-size: 24px">
              {{that.$root.language == 1?'2、产品指标':'2、PRODUCT INDEX'}}
            </div>
            <img v-if="that.$root.language == 1" v-show="item.img1" :src="item.img1"
                 style="width: 100%" />
            <img v-if="that.$root.language != 1" v-show="item.img1" :src="item.img1_en"
                 style="width: 100%" />
            <div class="bottom" style="padding: 20px 0; font-size: 24px">
              {{that.$root.language == 1?'3、应用性能比较':'3、TECHNICAL DATA'}}
            </div>
            <div v-show="item.compare1" class="compare" style="padding: 10px 0;text-indent: 2em">{{that.$root.language == 1?item.compare1:item.compare1_en}}</div>
            <div v-show="item.compare2" class="compare" style="padding: 10px 0;text-indent: 4em">{{that.$root.language == 1?item.compare2:item.compare2_en}}</div>
            <div v-show="item.compare3" class="compare" style="padding: 10px 0;text-indent: 4em">{{that.$root.language == 1?item.compare3:item.compare3_en}}</div>
            <div v-show="item.compare4" class="compare" style="padding: 10px 0;text-indent: 4em">{{that.$root.language == 1?item.compare4:item.compare4_en}}</div>
            <div v-show="item.compare5" class="compare" style="padding: 10px 0;text-indent: 4em">{{that.$root.language == 1?item.compare5:item.compare5_en}}</div>
            <div v-show="item.compare6" class="compare" style="padding: 10px 0;text-indent: 4em">{{that.$root.language == 1?item.compare6:item.compare6_en}}</div>
            <img v-if="that.$root.language == 1" v-show="item.img2" :src="item.img2" style="width: 100%" />
            <img v-if="that.$root.language != 1" v-show="item.img2" :src="item.img2_en" style="width: 100%" />
            <div class="remark">
              <div v-show="item.remark1" class="remarkFir" style="padding: 10px 0"> {{that.$root.language == 1?item.remark1:item.remark1_en}}</div>
              <div v-show="item.remark2" class="remarkSec" style="padding: 10px 0">{{that.$root.language == 1?item.remark2:item.remark2_en}}</div>
              <div v-show="item.remark3" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark3:item.remark3_en}}</div>
              <div v-show="item.remark4" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark4:item.remark4_en}}</div>
              <div v-show="item.remark5" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark5:item.remark5_en}}</div>
              <div v-show="item.remark6" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark6:item.remark6_en}}</div>
              <div v-show="item.remark7" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark7:item.remark7_en}}</div>
            </div>
            <div class="fourth" style="padding: 20px 0; font-size: 24px">
              {{that.$root.language == 1?'4、产品供应':'4、PRODUCT SUPPLY'}}
            </div>
            <div v-show="item.pack1" style="padding: 10px 0">{{that.$root.language == 1?item.pack1:item.pack1_en}}</div>
            <div v-show="item.pack2" style="padding: 10px 0">{{that.$root.language == 1?item.pack2:item.pack2_en}}</div>
            <div v-show="item.pack3" style="padding: 10px 0">{{that.$root.language == 1?item.pack3:item.pack3_en}}</div>
            <div v-show="item.pack4" style="padding: 10px 0">{{that.$root.language == 1?item.pack4:item.pack4_en}}</div>
          </div>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
        that:this,
        activeName: 'AL801',
      XJList: [
        {
          name: "AL801",
          textName: 'AL801特种炭黑',
          textName_en: 'AL801 SPECIAL CARBON BLACK',
          description1: 'AL801是安仑化工专门开发的应用于工业橡胶制品的特种炭黑，适用于挤出和模压橡胶制品，如汽车车门密封条、胶管、O型圈等。AL801炭黑的典型指标符合GB N550炭黑的目标值，具有以下优异性能：',
          description1_en: 'AL801 is a special carbon black specially developed by Anlun’s Chemical for industrial rubber \n' +
                        'products. It is suitable for extruding and molding rubber products, such as automotive door seals, \n' +
                        'extruded hoses and molded rubber parts. AL801 carbon black conforms to ASTM N550 carbon black \n' +
                        'target values, and has the following outstanding advantages.',
          description2: '超高洁净度：水洗筛余物控制在20ppm以下，挤出制品表面光洁度高，特别适用于汽车密封条等对外观要求很高的挤出橡胶制品；',
          description2_en: 'Ultra-high cleanliness: 325 sieve residue of AL801 is controlled to less than 20ppm, which \n' +
                        'is well-suited for extruded products needed high surface smoothness, such as automobile \n' +
                        'sealing strips and hoses;',
          description3: '优异的分散性：低比表面积、高结构和适中的聚结体尺寸分布保证AL801具有良好分散性\n' +
                        '能；精确调控的粒子强度，既保证AL801在橡胶中容易破碎、混入和分散，又满足工业生\n' +
                        '产所需的气力输送和自动化称量要求。',
          description3_en: 'Excellent dispersibility: Low surface area and high structure, and optimized aggregate size \n' +
                        'distribution is a guarantee of good dispersion. Meanwhile, its pellet hardness is well \n' +
                        'balanced in terms of processing, which is easy to be broken, mixed and dispersed in rubber \n' +
                        'compound, and has enough strength to ensure transportation, storage, pipeline \n' +
                        'transportation and automatic weighing.',
          remark1: '测试配方：EPDM 100份，炭黑 120份，石蜡油 70 份，氧化锌 5份，硫/促 7 份',
          remark1_en: '* Evaluation Recipe: EPDM 100 phr, Carbon Black 120 phr, Extender Oil 70 phr, ZnO 5 phr, Curative 7 phr',
          remark2: '*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark2_en: 'The data above are typical test values intended as guidance only.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：20kg PE袋/纸袋；500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 20kg PE; 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/xiangjiao/AL801-1.jpg"),
          img1_en: require("../../assets/img/xiangjiao/AL801-1-EN.jpg"),
          img2: require("../../assets/img/xiangjiao/AL801-2.jpg"),
          img2_en: require("../../assets/img/xiangjiao/AL801-2-EN.jpg"),
        },
        {
          name: "AL802",
          textName: 'AL802特种炭黑',
          textName_en: 'AL802 SPECIAL CARBON BLACK',
          description1: 'AL802是安仑化工专门开发的应用于工业橡胶制品的特种炭黑，适用于挤出和模压橡胶制品，\n' +
                        '如建筑门窗密封条、普通胶管、压力胶管、模压杂件等。AL802炭黑的典型指标符合GB N550炭黑\n' +
                        '的目标值，并具有以下两项优异性能：',
          description1_en: 'AL802 is a special carbon black specially developed by Anlun’s Chemical for industrial rubber \n' +
                        'products. It is suitable for extruding and molding rubber products, such as building profiles, common \n' +
                        'rubber hose, pressure rubber hose, and molded rubber parts, etc. AL802 carbon black conforms to \n' +
                        'ASTM N550 carbon black target values, and has the following two outstanding performances:',
          description2: '325目水洗筛余物控制在40ppm以下，挤出和模压制品表面光滑、瑕疵少；',
          description2_en: '325 sieve residue is controlled to less than 40ppm, then extruded and molded products have smooth surfaces with few defects.',
          description3: '优异的分散性能可缩短混炼时间，良好的挤出性能可延长滤网寿命，提高生产效率。',
          description3_en: 'Easy to disperse in rubber matrix can shorten mixing cycle, and prolong the life of filter screen during extrusion, then improving productivity.',
          remark1: '测试配方： EPDM 100 份，炭黑 120份，石蜡油 70 份，氧化锌 5份，硫/促 7份',
          remark1_en: '* Evaluation Recipe: EPDM 100 phr, Carbon Black 120 phr, Extender Oil 70 phr, ZnO 5 phr, Curative 7 phr',
          remark2: '*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark2_en: 'The data above are typical test values intended as guidance only.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：20kg PE袋/纸袋；500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 20kg PE; 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/xiangjiao/AL802-1.jpg"),
          img1_en: require("../../assets/img/xiangjiao/AL802-1-EN.jpg"),
          img2: require("../../assets/img/xiangjiao/AL802-2.jpg"),
          img2_en: require("../../assets/img/xiangjiao/AL802-2-EN.jpg"),
        },
        {
          name: "AL803",
          textName: 'AL803特种炭黑',
          textName_en: 'AL803 SPECIAL CARBON BLACK',
          description1: 'AL803是安仑化工专门开发的应用于工业橡胶制品的特种炭黑，具有与GB N550炭黑相当的橡胶补强性能。AL803具有高洁净度、易分散和优异挤出特性，适用汽车密封条、建筑型材和胶管等应用等。',
          description1_en: 'AL803 is a special carbon black specially developed by Anlun’s Chemical for industrial rubber \n' +
                        'products，it conforms to ASTM N539 carbon black target values. It has high cleanliness, easy \n' +
                        'dispersion and excellent extrusion characteristics, which is suitable for automobile sealing strips, \n' +
                        'building profiles, rubber hoses and other applications and has the following outstanding advantages.',
          description2: '提高填充量降低成本：具有较低的结构，在相同的门尼黏度、硬度和压变性能下，可增加5%的填充量；',
          description2_en: 'More loading to reduce cost: AL803 carbon black has low structure in comparison to AL802, \n' +
                        'which increase 5% more loading will achieve equal Mooney viscosity, hardness and \n' +
                        'compression.',
          description3: '提高生产效率：325目水洗筛余物控制在40ppm以下，挤出制品表面光洁度高；与AL801和AL802相比，AL803的门尼黏度较低可增加挤出速度，提高生产效率。',
          description3_en: 'High productivity: AL803 is controlled 325 sieve residue to less than 40 ppm, meanwhile \n' +
                        'rubber compound has low Mooney viscosity and supports to increase extrusion speed and \n' +
                        'improve productivity.',
          description4: '平衡的分散和气力输送性能：精确调控的粒子强度，既保证AL801在橡胶中的容易破碎、混入和分散，又满足工业生产所需的气力输送和自动化称量要求。',
          description4_en: 'Balanced dispersion and air conveying: Its pellet hardness is well balanced, which is easy to \n' +
                        'be broken, mixed and dispersed in rubber compound, and has enough strength to ensure \n' +
                        'transportation, storage, pipeline transportation and automatic weighing.',
          remark1: '测试配方： EPDM 100 份，炭黑 120份，石蜡油 70 份，氧化锌 5份，硫/促 7份',
          remark1_en: 'Evaluation Recipe: EPDM 100 phr, Carbon Black 120 phr, Extender Oil 70 phr, ZnO 5 phr, Curative 7 phr',
          remark2: '*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark2_en: '* The data above are typical test values intended as guidance only.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：20kg PE袋/纸袋；500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 20kg PE; 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/xiangjiao/AL803-1.jpg"),
          img1_en: require("../../assets/img/xiangjiao/AL803-1-EN.jpg"),
          img2: require("../../assets/img/xiangjiao/AL803-2.jpg"),
          img2_en: require("../../assets/img/xiangjiao/AL803-2-EN.jpg"),
        },
        {
          name: "AL804",
          textName: 'AL804特种炭黑',
          textName_en: 'AL804 SPECIAL CARBON BLACK',
          description1: 'AL804是安仑化工专门开发的应用于工业橡胶制品的特种炭黑，是一款高纯净度半补强级别产品，特别适用于橡胶制品，如挡风雨条、冷却胶管、密封圈、减震件等。',
          description1_en: 'AL804 is a special carbon black specially developed by Anlun’s Chemical for industrial rubber \n' +
                        'products. AL804 is a high purity and semi-reinforcing carbon black, especially suitable for rubber \n' +
                        'products, such as weathering strip, cooling hose, seals, anti-vibration, etc.',
          description2: 'AL804炭黑的典型指标符合GB N774炭黑的目标值，并具有以下突出性能：',
          description2_en: 'AL804 carbon black conforms to ASTM N774 carbon black target values, and has the following outstanding advantages:',
          description3: '高洁净：325目水洗筛余物控制在20ppm以下，挤出和模压制品表面外观光滑，缺陷少；',
          description3_en: 'High cleanliness: 325 sieve residue is controlled to less than 20ppm, whose extruded and moulded products have smooth surface and less defect.',
          description4: '易加工：在胶料中易于分散并减少因分散不良造成的表面缺陷；胶料门尼黏度低，可快速挤出提出生产效率。',
          description4_en: 'Easy processing: AL804 is easy to disperse in rubber matrix then reduce risk of surface \n' +
                        'defects caused by poor dispersion; rubber compound has low Mooney viscosity and \n' +
                        'supports to increase extrusion speed and improve productivity.',
          remark1: '测试配方： EPDM 100 份、炭黑 120份、石蜡油 70 份、氧化锌 5份、硫/促 7份',
          remark1_en: 'Evaluation recipe: EPDM 100 phr, Carbon Black 120 phr, Paraffin Oil 70 phr, ZnO 5 phr, Curative 7 phr',
          remark2: '*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark2_en: '* The data above are typical test values intended as guidance only.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：20kg PE袋/纸袋；500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 20kg PE; 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/xiangjiao/AL804-1.jpg"),
          img1_en: require("../../assets/img/xiangjiao/AL804-1-EN.jpg"),
          img2: require("../../assets/img/xiangjiao/AL804-2.jpg"),
          img2_en: require("../../assets/img/xiangjiao/AL804-2-EN.jpg"),
        },
        {
          name: "AL805",
          textName: 'AL805特种炭黑',
          textName_en: 'AL805 Special carbon black',
          description1: 'AL805是安仑化工开发的应用于工业橡胶制品的特种炭黑，具有高洁净度、易分散和优异的挤\n' +
                        '出特性，主要用于汽车密封条、建筑型材和胶管等橡胶制品中。与AL801或AL802炭黑相比，\n' +
                        'AL805具有相似的结构、更低的比表面积，使用中具有以下优异性能：',
          description1_en: 'AL805 is a special carbon black launched by Anlun’s Chemical for industrial rubber products. It \n' +
                        'combined high cleanliness, easy dispersion and excellent extrusion characteristics, which is suitable \n' +
                        'for automobile sealing strips, building profiles and rubber hoses. Compared with AL801 or AL802 \n' +
                        'carbon black, AL805 has the same structure but low surface area:',
          description2: '更加易于混入橡胶中并获得良好分散；',
          description2_en: 'Easy to be incorporated and dispersed in rubber matrix;',
          description3: '相同胶料硬度下，可增加10%的炭黑填充量以降低成本；',
          description3_en: 'More loading of 10% for cost saving based on the comparable hardness;',
          description4: '相同炭黑填充量时，胶料的回弹性好，压缩永久变形小；',
          description4_en: 'Low compression set and high rebound based on equal carbon black loading;',
          description5: '高纯净度和良好分散保证挤出物表面光滑，降低废品率;',
          description5_en: 'High purity and excellent dispersion to ensure the surface smoothness of extrudate;',
          description6: '门尼黏度低，可增加挤出速度，提高生产效率。',
          description6_en: 'Low Mooney viscosity support to increase extrusion speed then improve productivity.',
          remark1: '测试配方：EPDM 100 份，炭黑 120份，石蜡油 70 份，氧化锌 5份，硫/促 7份',
          remark1_en: 'Evaluation Recipe: EPDM 100 phr, Carbon Black 120 phr, Paraffin Oil 70 phr, ZnO 5 phr, Curative 7 phr',
          remark2: '*以上典型数据仅供参考，配方、工艺等或有差异需依实际情况而定。',
          remark2_en: '* The data above are typical test values intended as guidance only.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：20kg PE袋/纸袋；500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging：20kg PE；500kg FIBC；1,000kg FIBC',
          img1: require("../../assets/img/xiangjiao/AL804-1.jpg"),
          img1_en: require("../../assets/img/xiangjiao/AL804-1-EN.jpg"),
          img2: require("../../assets/img/xiangjiao/AL804-2.jpg"),
          img2_en: require("../../assets/img/xiangjiao/AL804-2-EN.jpg"),
        },
        {
          name: "AL8000",
          textName: 'AL8000特种炭黑',
          textName_en: 'AL8000 SPECIAL CARBON BLACK',
          description1: 'AL8000是安仑化工专门开发的应用于工业橡胶制品的特种炭黑，尤其适用于挤出橡胶应用，如汽车车门密封条、雨刮条、挤出软管等。',
          description1_en: 'AL8000 is a special carbon black specially developed by Anlun’s Chemical for industrial rubber \n' +
                        'products，especially suitable for extrusion rubber applications, such as auto weathering seals, wiper \n' +
                        'strips, extrusion hose, etc.',
          description2: '与AL801相比，AL8000具有相同级别的洁净度和同样精确调控的粒子强度，同时具有更加优\n' +
                        '异的分散性能：从炭黑形态来讲，比表面积越小、结构越高（特别是吸油值与压缩吸油值的差值\n' +
                        '越大），炭黑越容易分散。与AL801炭黑相比，AL8000具有相同的结构但更低的比表面积，更易\n' +
                        '分散，可以缩短混炼时间提高生产效率，特别是明显减少因分散不良而引起的挤出表面缺陷。',
          _en: 'Compared with N550 carbon black, AL8000 has the same cleaniness level, the same optimized pellet \n' +
                        'hardness, but easy to disperse. In terms of morphology, AL8000 has the same structure and low \n' +
                        'surface area, which can shorten the mixing time then improve productivity. Meanwhile, excellent \n' +
                        'dispersion will eliminate the surface defects caused by big agglomerate.',
          description7: '注：沿箭头方向的炭黑更易分散。',
          description7_en: ' ',
          compare1: '与 AL801（超纯净的 N550）相比，AL8000 具有以下优异性能：',
          compare1_en: 'Compared with AL801 (high purity N550), AL8000 has the following outstanding benefit:',
          compare2: '相同胶料硬度时，可增加 5%-10%的炭黑填充量，降低配方成本；',
          compare2_en: 'AL8000 can be increased by 5%-10% carbon black loading which has the comparable hardness.',
          compare3: '优异的分散性可缩短混炼时间，快速挤出性能可提高生产效率。',
          compare3_en: 'More productivity: AL8000 is easy to disperse in rubber matrix then reduce risk of surface defects caused by poor dispersion; rubber compound has low Mooney viscosity and \n' +
                    'supports to increase extrusion speed and to improve productivity.',
          remark1: '*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark1_en: '* The data above are typical test values intended as guidance only',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：20kg PE袋/纸袋；500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 20kg PE; 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/xiangjiao/AL8000-2.jpg"),
          img1_en: require("../../assets/img/xiangjiao/AL8000-2-EN.jpg"),
          img2: require("../../assets/img/xiangjiao/AL8000-3.jpg"),
          img2_en: require("../../assets/img/xiangjiao/AL8000-3-EN.jpg"),
          img3: require("../../assets/img/xiangjiao/AL8000-1.jpg"),
          img3_en: require("../../assets/img/xiangjiao/AL8000-1-EN.jpg"),
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
  width: 150px;
}
::v-deep .el-tabs__item.is-active {
  background-color: rgba($color: #000000, $alpha: 0.1);
}
::v-deep .el-tabs__nav{
  background-color: #ffffff !important;
  color: #000000 !important;
}
::v-deep .el-tabs__item.is-active {
  color: #ee7a18 !important;
}
::v-deep .el-tabs__item:hover {
    color: #ee7a18 !important;
    cursor: pointer !important;
}
::v-deep #tab-AL801 {
  text-align: center;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
}
::v-deep #tab-AL802 {
  text-align: center;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
}
::v-deep #tab-AL803 {
  text-align: center;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
}
::v-deep #tab-AL804 {
  text-align: center;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
}
::v-deep #tab-AL805 {
  text-align: center;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
}
::v-deep #tab-AL8000 {
  text-align: center;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
}
</style>